// copied from v1
import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Box } from "@indeed/ifl-components";

const FeatureImage = ({ altText, fluidImage, sx }) => {
  const heroImages = {
    borderRadius: ["none", "none", "md", "md"],
    marginLeft: ["-10vw", "-10vw", 0, 0],
    marginRight: ["-10vw", "-10vw", 0, 0],
    maxWidth: "100vw",
    width: ["100vw", "100vw", "100%", "100%"],
    mb: [6, null, null, null],
  };
  const imgStyles = {
    borderRadius: "md",
    display: "block",
    margin: 0,
    maxWidth: "100%",
    objectFit: "cover",
    boxShadow: "brandcustom",
  };
  return (
    <Box
      as={GatsbyImage}
      role="presentation"
      image={fluidImage}
      alt={altText}
      sx={{
        ...imgStyles,
        ...heroImages,
        ...sx,
      }}
    />
  );
};

export default FeatureImage;
